'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { createPath, createPathFromFile } from 'DesignData/helpers/routingHelper';
import FileModel from 'DesignData/models/finder/File';
import { FilePropTypes, FolderPropTypes } from 'DesignData/propTypes/finder';
import ResultItem from 'DesignFinderUI/components/results/ResultItem';
import { getIconNameFromFolderAssetType } from 'DesignData/lib/icon';
import * as FoldersActions from 'DesignData/actions/finder/Folders';
import * as Selections from 'DesignData/actions/finder/Selections';
import { getIsFolderOpen } from 'DesignData/selectors/finder';
import * as AssetSources from 'DesignData/enums/AssetSources';
import withConnectedFile from 'DesignFinderUI/hocs/withConnectedFile';
import { fileDragSource } from 'DesignFinderUI/components/dnd/FileDragDrop';
import withHideDefaultDragPreview from 'DesignComponents/decorators/withHideDefaultDragPreview';
import { compose } from 'redux';

const i18nKey = key => `DesignFinderUI.results.AssetResultItem.${key}`;

function makeMapStateToProps() {
  return function mapStateToProps(state, props) {
    return {
      isFolderOpen: getIsFolderOpen(state, props)
    };
  };
}

const mapDispatchToProps = {
  openFolder: FoldersActions.openDeeplyNestedFolder,
  selectFile: Selections.selectFile,
  revealInFinder: Selections.revealInFinder
};

class FileResultItem extends PureComponent {
  constructor(...args) {
    super(...args);

    this.handleItemButtonClick = () => {
      this.props.onButtonClick(this.props.fileId);
    };

    this.handleFileNameClick = () => {
      const {
        isFolderOpen,
        openFolder,
        onClose,
        selectFile,
        revealInFinder,
        fileId,
        folderId,
        fileType
      } = this.props;

      if (!isFolderOpen) {
        if (folderId) openFolder(folderId);
      }

      onClose();
      this.fileNameClickTimeout = setTimeout(() => {
        selectFile(fileId, fileType, folderId);
        revealInFinder(fileId);
      });
    };
  }

  componentWillUnmount() {
    clearTimeout(this.fileNameClickTimeout);
  }

  render() {
    const _this$props = this.props,
          {
      asLink,
      buttonText,
      fileType,
      folderPath: __folderPath,
      fileId,
      name: __name,
      connectDragSource,
      showIcon,
      path
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["asLink", "buttonText", "fileType", "folderPath", "fileId", "name", "connectDragSource", "showIcon", "path"]);

    const designAssetType = FileModel.getDesignAssetType(fileType);
    const iconName = getIconNameFromFolderAssetType(fileType, path);

    const name = /*#__PURE__*/_jsx(UITruncateString, {
      children: __name
    });

    let fileName;

    if (!asLink) {
      fileName = name;
    } else {
      const {
        file,
        assetSource
      } = this.props;
      const to = createPathFromFile(file) || createPath(designAssetType, fileId, {
        assetSource
      });
      fileName = /*#__PURE__*/_jsx(UIRouterLink, {
        to: to,
        onClick: this.handleFileNameClick,
        children: name
      });
    }

    const folderPath = __folderPath ? /*#__PURE__*/_jsx(UITruncateString, {
      tooltip: __folderPath,
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: i18nKey('folderPath'),
        options: {
          folderPath: __folderPath
        }
      })
    }) : null;
    return connectDragSource( /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(ResultItem, Object.assign({}, rest, {
        buttonText: buttonText,
        help: folderPath,
        icon: showIcon && iconName,
        onButtonClick: this.handleItemButtonClick,
        title: fileName
      }))
    }));
  }

}

FileResultItem.propTypes = {
  asLink: PropTypes.bool,
  assetSource: PropTypes.oneOf(Object.values(AssetSources)),
  buttonText: PropTypes.node,
  connectDragSource: PropTypes.func,
  fileType: FilePropTypes.fileType.isRequired,
  folderId: FolderPropTypes.folderId,
  folderPath: PropTypes.string,
  file: PropTypes.instanceOf(FileModel).isRequired,
  fileId: FilePropTypes.fileId.isRequired,
  isFolderOpen: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onButtonClick: PropTypes.func,
  onClose: PropTypes.func,
  openFolder: PropTypes.func.isRequired,
  path: PropTypes.string,
  selectFile: PropTypes.func.isRequired,
  revealInFinder: PropTypes.func.isRequired,
  showIcon: PropTypes.bool
};
FileResultItem.defaultProps = {
  asLink: true,
  buttonText: null,
  folderPath: null,
  itemButtonText: null,
  onButtonClick: emptyFunction,
  onClose: emptyFunction,
  path: '',
  showIcon: true
};
export default compose(connect(makeMapStateToProps, mapDispatchToProps), withConnectedFile, fileDragSource, withHideDefaultDragPreview())(FileResultItem);